import {
  HStack,
  IconButton,
  Tab,
  TabList,
  UseDisclosureReturn
} from "@chakra-ui/react"
import { AugmentationToolbarHookReturn } from "@pathwright/ux/src/components/augmentation/AugmentationToolbar"
import Pathicon from "../../pathicon/Pathicon"

type CertificateAugmentationHeaderProps = {
  toolbar: AugmentationToolbarHookReturn
  disclosure?: UseDisclosureReturn
}

const CertificateAugmentationHeader = ({
  toolbar,
  disclosure
}: CertificateAugmentationHeaderProps) => {
  return (
    <HStack w="100%" justifyContent="space-between">
      {/* TODO: consider a AugmenationTabList? */}
      <TabList
        paddingLeft={2}
        paddingRight={2}
        justifyContent="center"
        borderBottom="none"
        w="100%"
      >
        {toolbar.options.map((option) => (
          <Tab
            key={option.key}
            gap={1}
            fontWeight="bold"
            borderBottom="none"
            opacity=".45"
            _selected={{ color: "black", opacity: "1" }}
            onClick={() => toolbar.onSelect(option.key)}
            borderRadius="20px"
          >
            <Pathicon icon={option.icon} size="1em" /> {option.label}
          </Tab>
        ))}
      </TabList>

      {!!disclosure && (
        <IconButton
          {...disclosure.getButtonProps()}
          icon={<Pathicon icon="x" />}
          h={8}
          minW={8}
          isRound
          cursor="pointer"
          colorScheme="blackAlpha"
          variant="ghost"
        />
      )}
    </HStack>
  )
}

export default CertificateAugmentationHeader
